// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-950a281c]:export{menuBg:#414146;menuText:#e0e3da;menuActiveText:#fffff3}.box[data-v-950a281c]{width:100;height:100%;background:#fff;padding:20px;box-sizing:border-box}.exportBox[data-v-950a281c]{width:800px}.flex[data-v-950a281c]{display:flex}", ""]);
// Exports
module.exports = exports;
